module.exports = __webpack_public_path__ + "img/clicksign_logo.46aba09a.png";